// src/js/config/saveToBrowser.js

import { collectFormData } from './configFormHandler.js';
import { getAllOrderConfigs } from './configLoader.js';
import { showMessage } from './ui/showMessage.js';
import { showConfirmSaveModal } from './ui/confirmSaveModal.js';
import { showPromptForNameModal } from './ui/promptForNameModal.js';
import { performSave } from './performSave.js'; // <-- NY IMPORT

export function saveToBrowser() {
    const strings = window.SimP_Strings || {};
    let currentConfigData = collectFormData();

    if (!currentConfigData || !currentConfigData.name) {
        showMessage(strings.save_warning_missing_name || 'Ange ett namn för konfigurationen.', 'warning');
        return;
    }

    const configName = currentConfigData.name;
    const existingConfigs = getAllOrderConfigs();
    const nameExists = existingConfigs.some(config => config.name.toLowerCase() === configName.toLowerCase());

    if (nameExists) {
        showConfirmSaveModal(
            configName,
            () => { performSave(currentConfigData); }, // Anropar den importerade funktionen
            () => {
                showPromptForNameModal(
                    configName,
                    (newName) => {
                        const updatedConfigData = { ...currentConfigData, name: newName };
                        performSave(updatedConfigData); // Anropar den importerade funktionen
                    }
                );
            },
            () => { showMessage(strings.save_info || 'Sparningen avbröts.', 'info'); }
        );
    } else {
        performSave(currentConfigData); // Anropar den importerade funktionen
    }
}